class ProductSlider {
  constructor() {
    this.slider = document.querySelector('[id^="GalleryViewer-"]');
    this.slides = this.slider?.querySelectorAll('.slider__slide');
    this.dots = document.querySelectorAll('.slider-dot');
    
    this.init();
  }

  init() {
    if (!this.slider || !this.slides.length) return;

    // Handle dot clicks
    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.slideIndex);
        this.goToSlide(index);
      });
    });

    // Listen for slide changes from the slider
    this.slider.addEventListener('slideChanged', (event) => {
      const currentSlide = event.detail.currentElement;
      const index = Array.from(this.slides).indexOf(currentSlide);
      this.updateDots(index);
    });
  }

  goToSlide(index) {
    // Hide all slides
    this.slides.forEach(slide => {
      slide.classList.add('hide');
    });
    
    // Show selected slide
    this.slides[index].classList.remove('hide');
    
    // Update dots
    this.updateDots(index);
    
    // Dispatch event for other components
    this.slider.dispatchEvent(new CustomEvent('slideChanged', {
      detail: {
        currentElement: this.slides[index]
      }
    }));
  }

  updateDots(activeIndex) {
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === activeIndex);
    });
  }
}

// Initialize on DOM load
customElements.define('product-slider', class extends HTMLElement {
  connectedCallback() {
    new ProductSlider();
  }
});
